/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 * Generated by: scripts/generate-template-loaders.js
 * Source files:
 *   - classic.njk
 *   - classic.css
 */

export const CLASSIC_TEMPLATE = `<div class="wrap">
  <div class="hdr">
    <h2>{{ storeName }}</h2>
    {% if address %}<p>{{ address | replace('\\n', '<br/>') | safe }}</p>{% endif %}
    {% if phone %}<p>Tel: {{ phone }}</p>{% endif %}
  </div>

  <div class="meta">
    <div>
      <p><span class="meta-lbl">Bill To:</span> {{ customerName }}</p>
      {% if customerPhone %}<p><span class="meta-lbl">Tel:</span> {{ customerPhone }}</p>{% endif %}
      {% if customerAddress %}<p><span class="meta-lbl">Addr:</span> {{ customerAddress }}</p>{% endif %}
    </div>
    <div style="text-align:right">
      <p><span class="meta-lbl">Invoice #:</span> {{ orderNo }}</p>
      <p><span class="meta-lbl">Date:</span> {{ dateStr }}</p>
      <p><span class="meta-lbl">Time:</span> {{ timeStr }}</p>
      <p><span class="meta-lbl">Type:</span> {{ sellingType }}</p>
    </div>
  </div>

  <table>
    <thead>
      <tr>
        <th align="left">Description</th>
        <th align="center">Qty</th>
        <th align="right">Rate</th>
        <th align="right">Total</th>
      </tr>
    </thead>
    <tbody>
      {% for item in items %}
      <tr>
        <td>
          {{ item.product_name or item.item_name or "Product" }}
          {% if item.batch_no %}<br/><small style="color:#777">Batch: {{ item.batch_no }}</small>{% endif %}
        </td>
        <td align="center">{{ item.quantity }}</td>
        <td align="right">{{ item.price | formatPrice }}</td>
        <td align="right"><b>{{ item.total_price | formatPrice }}</b></td>
      </tr>
      {% endfor %}
    </tbody>
  </table>

  <div class="dashes"></div>

  <div class="row">
    <span>Subtotal</span>
    <span>{{ currency }} {{ subtotal | formatPrice }}</span>
  </div>
  {% if showDisc %}
  <div class="row disc">
    <span>Discount</span>
    <span>- {{ currency }} {{ discountAmount | formatPrice }}</span>
  </div>
  {% endif %}
  {% if showExch %}
  <div class="row disc">
    <span>Exchange Disc.</span>
    <span>- {{ currency }} {{ exchangeAmount | formatPrice }}</span>
  </div>
  {% endif %}
  {% if showChg %}
  <div class="row">
    <span>Other Charges</span>
    <span>{{ currency }} {{ otherCharges | formatPrice }}</span>
  </div>
  {% endif %}
  <div class="row grand">
    <span>GRAND TOTAL</span>
    <span>{{ currency }} {{ grandTotal | formatPrice }}</span>
  </div>

  <div class="dashes"></div>

  {% if payments.length > 0 %}
  <div class="pay-section">
    <h4>Payments Received</h4>
    {% for p in payments %}
    <div class="row">
      <span>{{ p.payment_method_name or p.payment_method_code or "Payment" }}</span>
      <span>{{ currency }} {{ p.amount | formatPrice }}</span>
    </div>
    {% endfor %}
  </div>
  {% endif %}

  <div class="row paid">
    <span>Total Paid</span>
    <span style="color:#16a34a">{{ currency }} {{ paidAmount | formatPrice }}</span>
  </div>
  <div class="row due">
    <span>Balance Due</span>
    <span style="{% if hasDue %}color:#b91c1c{% else %}color:#16a34a{% endif %}">
      {{ currency }} {{ dueAmount | formatPrice }}
    </span>
  </div>

  <div class="ftr">
    <p>{{ footer }}</p>
    <p style="margin-top:6px;font-size:0.85em">Powered by TaproDev POS</p>
  </div>
</div>
`;

export const CLASSIC_CSS = `*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Courier New', Courier, monospace;
  font-size: var(--inv-font, 13px);
  color: #111;
  background: var(--inv-bg, #e5e7eb);
  padding: var(--inv-body-pad, 24px 16px);
}

.wrap {
  width: var(--inv-width, 210mm);
  max-width: 100%;
  margin: 0 auto;
  background: #fff;
  padding: var(--inv-pad, 18mm);
  box-shadow: var(--inv-shadow, 0 4px 16px rgba(0,0,0,0.10));
  border-radius: var(--inv-radius, 4px);
}

h2 {
  font-size: var(--inv-h2-size, 1.3em);
  font-weight: bold;
  text-align: center;
  margin-bottom: 4px;
}

p {
  line-height: 1.55;
  font-size: var(--inv-p-size, 0.9em);
}

.hdr {
  text-align: center;
  border-bottom: 1px dashed #555;
  padding-bottom: 10px;
  margin-bottom: 10px;
}

.hdr p { color: #444; }

.meta {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px dashed #999;
}

.meta-lbl { font-weight: bold; }

table {
  width: 100%;
  border-collapse: collapse;
  margin: 10px 0;
  font-size: 0.92em;
}

thead tr {
  border-top: 1px solid #111;
  border-bottom: 1px solid #111;
}

thead th { padding: var(--inv-th-pad, 7px 6px); font-weight: bold; }
tbody td { padding: var(--inv-td-pad, 7px 6px); border-bottom: 1px dashed #ccc; }

.row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 3px 0;
  font-size: 0.92em;
  gap: 8px;
}

.row.disc  { color: #b91c1c; }
.row.grand {
  font-weight: bold;
  font-size: var(--inv-grand-size, 1.1em);
  border-top: 1px solid #111;
  padding-top: 6px;
  margin-top: 4px;
}
.row.paid { font-weight: bold; }
.row.due  { font-weight: bold; }

.dashes { border-top: 1px dashed #555; margin: 8px 0; }

.pay-section { margin: 8px 0; font-size: 0.88em; }
.pay-section h4 {
  font-weight: bold;
  margin-bottom: 4px;
  font-size: 0.85em;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ftr {
  text-align: center;
  margin-top: var(--inv-ftr-mt, 24px);
  border-top: 1px dashed #999;
  padding-top: 10px;
  color: #555;
  font-size: var(--inv-ftr-size, 0.82em);
}

@media print {
  body  { background: #fff; padding: 0; }
  .wrap { box-shadow: none; border-radius: 0; width: 100% !important; }
  @page { size: var(--inv-page-size, A4); margin: 0; }
}
`;
